<soft-ds-date-range-comparison-picker size="md"
                                      [value]="pickerValue()"
                                      [fiscalYearStart]="fiscalYearStart()"
                                      (apply)="apply($event)"
                                      data-testid="filter-menu-bar-date-range-reference-picker" />
